import { render, staticRenderFns } from "./account-setting.vue?vue&type=template&id=6b377ec4"
import script from "./account-setting.vue?vue&type=script&lang=js"
export * from "./account-setting.vue?vue&type=script&lang=js"
import style0 from "./account-setting.vue?vue&type=style&index=0&id=6b377ec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports